/**
 * Component which renders a spinner that can be used as the only content
 * of the page to indicate that something is still loading and the user should
 * wait.
 */
import {StyleSheet} from "aphrodite";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Spring} from "@khanacademy/wonder-blocks-layout";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";

export default class LoadingSpinner extends React.Component<Record<any, any>> {
    render(): React.ReactNode {
        return (
            <View style={styles.spinnerWrapper}>
                <Spring />
                <CircularSpinner size="medium" />
                <Spring />
            </View>
        );
    }
}

const styles = StyleSheet.create({
    spinnerWrapper: {
        flexDirection: "row",
        // This mimicks the route loading spinner so that there isn't excessive
        // jumping of the UI when this shows.
        marginTop: 40,
        marginBottom: 40,
    },
});
